import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStep10 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Shield_Protected.4",
	"data-name": "Shield, Protected.4",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11673",
			"data-name": "Path 11673",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11674",
			"data-name": "Path 11674",
			d: "M20,11.182A10.343,10.343,0,0,1,12,21a10.343,10.343,0,0,1-8-9.818V7.615A2,2,0,0,1,5.243,5.764l5-2.046a4.637,4.637,0,0,1,3.514,0l5,2.046A2,2,0,0,1,20,7.615Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_11675",
			"data-name": "Path 11675",
			d: "M15.25,10.125l-3.75,3.75-2.25-2.25",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgStep10;
